// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Uuid from "../../externals/Uuid.res.js";
import * as Uuid$1 from "uuid";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Request from "../../core/Request.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as InfoBlock from "../../resources/layout-and-structure/InfoBlock.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as LegacyIcon from "../../resources/images-and-icons/LegacyIcon.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as CatalogLabel from "../../modules/Catalog/CatalogLabel.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as CatalogRoutes from "./CatalogRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Client from "@apollo/client";
import * as CatalogProduct from "../../modules/Catalog/CatalogProduct.res.js";
import * as SettingsRoutes from "../Settings/SettingsRoutes.res.js";
import * as TriggerDownload from "../../primitives/TriggerDownload.res.js";
import * as UserPreferences from "../../core/UserPreferences.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ResourceDetailsPage from "../../core/ResourceDetailsPage.res.js";
import * as InputRadioGroupField from "../../resources/selection-and-input/InputRadioGroupField.res.js";
import * as InputToggleSwitchField from "../../resources/selection-and-input/InputToggleSwitchField.res.js";
import * as CatalogPlaceholderShopPicker from "../../modules/Catalog/CatalogPlaceholderShopPicker.res.js";
import * as LegacyProductReferenceTableCell from "../../modules/Product/LegacyProductReferenceTableCell.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
import * as CatalogLabelProductsPickerModalTable from "../../modules/Catalog/CatalogLabelProductsPickerModalTable.res.js";
let initial = {
  TAG: "Picked",
  _0: []
};
let CatalogLabelCreateProductsValue = {
  initial: initial
};
function initialValues(priceId, productBarcodeDisplayedOpt, missingProductBarcodeGeneratedOpt, priceDisplayedOpt, producerDisplayedOpt, alcoholVolumeDisplayedOpt, designationDisplayedOpt, productCodeOpt, labelFormatOpt, printOffsetOpt, borderEnabledOpt, sortOpt, param) {
  let productBarcodeDisplayed = productBarcodeDisplayedOpt !== undefined ? productBarcodeDisplayedOpt : false;
  let missingProductBarcodeGenerated = missingProductBarcodeGeneratedOpt !== undefined ? missingProductBarcodeGeneratedOpt : false;
  let priceDisplayed = priceDisplayedOpt !== undefined ? priceDisplayedOpt : true;
  let producerDisplayed = producerDisplayedOpt !== undefined ? producerDisplayedOpt : false;
  let alcoholVolumeDisplayed = alcoholVolumeDisplayedOpt !== undefined ? alcoholVolumeDisplayedOpt : false;
  let designationDisplayed = designationDisplayedOpt !== undefined ? designationDisplayedOpt : false;
  let productCode = productCodeOpt !== undefined ? productCodeOpt : "Hidden";
  let labelFormat = labelFormatOpt !== undefined ? labelFormatOpt : "Grid21";
  let printOffset = printOffsetOpt !== undefined ? printOffsetOpt : 1;
  let borderEnabled = borderEnabledOpt !== undefined ? borderEnabledOpt : false;
  let sort = sortOpt !== undefined ? sortOpt : "Unsorted";
  return {
    priceId: priceId,
    productBarcodeDisplayed: productBarcodeDisplayed,
    missingProductBarcodeGenerated: missingProductBarcodeGenerated,
    priceDisplayed: priceDisplayed,
    producerDisplayed: producerDisplayed,
    alcoholVolumeDisplayed: alcoholVolumeDisplayed,
    designationDisplayed: designationDisplayed,
    productCode: productCode,
    labelFormat: labelFormat,
    printOffset: printOffset,
    borderEnabled: borderEnabled,
    sort: sort,
    productValues: initial
  };
}
function errorMessagesFromValues(values) {
  let productValues = values.productValues;
  let printOffset = values.printOffset;
  let labelFormat = values.labelFormat;
  let maxOffset = CatalogLabel.Sheet.LabelFormat.toMaxOffset(labelFormat);
  let tmp;
  tmp = labelFormat === "Grid21" ? printOffset > maxOffset || printOffset < 1 ? I18n.template(I18n.t("This number must range between {{min}} and {{max}} inclusive."), {
    min: 1,
    max: maxOffset
  }, undefined) : undefined : printOffset > maxOffset || printOffset < 1 ? I18n.template(I18n.t("This number must range between {{min}} and {{max}} inclusive."), {
    min: 1,
    max: maxOffset
  }, undefined) : undefined;
  let tmp$1;
  tmp$1 = typeof productValues !== "object" || productValues._0.length !== 0 ? undefined : I18n.t("Please select at least one product.");
  return {
    printOffset: tmp,
    productValues: tmp$1
  };
}
let CatalogLabelCreateLabelSheetForm = {
  initialValues: initialValues,
  errorMessagesFromValues: errorMessagesFromValues
};
function initialValues$1(priceId, productBarcodeDisplayedOpt, missingProductBarcodeGeneratedOpt, priceDisplayedOpt, producerDisplayedOpt, alcoholVolumeDisplayedOpt, designationDisplayedOpt, productCodeOpt, labelFormatOpt, param) {
  let productBarcodeDisplayed = productBarcodeDisplayedOpt !== undefined ? productBarcodeDisplayedOpt : false;
  let missingProductBarcodeGenerated = missingProductBarcodeGeneratedOpt !== undefined ? missingProductBarcodeGeneratedOpt : false;
  let priceDisplayed = priceDisplayedOpt !== undefined ? priceDisplayedOpt : true;
  let producerDisplayed = producerDisplayedOpt !== undefined ? producerDisplayedOpt : false;
  let alcoholVolumeDisplayed = alcoholVolumeDisplayedOpt !== undefined ? alcoholVolumeDisplayedOpt : false;
  let designationDisplayed = designationDisplayedOpt !== undefined ? designationDisplayedOpt : false;
  let productCode = productCodeOpt !== undefined ? productCodeOpt : "Hidden";
  let labelFormat = labelFormatOpt !== undefined ? labelFormatOpt : "Label31x22";
  return {
    priceId: priceId,
    productBarcodeDisplayed: productBarcodeDisplayed,
    missingProductBarcodeGenerated: missingProductBarcodeGenerated,
    priceDisplayed: priceDisplayed,
    producerDisplayed: producerDisplayed,
    alcoholVolumeDisplayed: alcoholVolumeDisplayed,
    designationDisplayed: designationDisplayed,
    productCode: productCode,
    labelFormat: labelFormat,
    productValues: initial
  };
}
function errorMessagesFromValues$1(values) {
  let match = values.productValues;
  let tmp;
  tmp = typeof match !== "object" || match._0.length !== 0 ? undefined : I18n.t("Please select at least one product.");
  return {
    productValues: tmp
  };
}
let CatalogLabelCreateLabelPrintForm = {
  initialValues: initialValues$1,
  errorMessagesFromValues: errorMessagesFromValues$1
};
let validationErrorText = I18n.t("There are some errors in the form, please correct them before trying to send it again.");
function isErrored(state) {
  let match = state.form;
  if (match.TAG === "LabelSheet") {
    let match$1 = match._0;
    let match$2 = match$1.submitResult;
    if (typeof match$2 !== "object") {
      if (match$2 === "NotAsked") {
        return false;
      }
    } else {
      if (match$2.TAG === "Reloading") {
        return false;
      }
      if (match$2._0.TAG === "Ok") {
        return false;
      }
    }
    let errorMessages = match$1.errorMessages;
    if (Stdlib_Option.isSome(errorMessages.printOffset)) {
      return true;
    } else {
      return Stdlib_Option.isSome(errorMessages.productValues);
    }
  }
  let match$3 = match._0;
  if (match$3.settingsOnly !== undefined) {
    return false;
  }
  let match$4 = match$3.submitResult;
  if (typeof match$4 !== "object") {
    if (match$4 === "NotAsked") {
      return false;
    } else {
      return Stdlib_Option.isSome(match$3.errorMessages.productValues);
    }
  } else if (match$4.TAG === "Reloading" || match$4._0.TAG === "Ok") {
    return false;
  } else {
    return Stdlib_Option.isSome(match$3.errorMessages.productValues);
  }
}
function isPrintMode(state) {
  let match = state.form;
  return match.TAG !== "LabelSheet";
}
function isSettingsOnlyMode(state) {
  let match = state.form;
  if (match.TAG === "LabelSheet") {
    return false;
  } else {
    return Stdlib_Option.isSome(match._0.settingsOnly);
  }
}
function defaultPriceIdFromPriceList(priceList) {
  let defaultPriceItem = priceList.find(priceItem => priceItem.default);
  let match = priceList[0];
  if (defaultPriceItem !== undefined) {
    return Primitive_option.some(defaultPriceItem.id);
  } else if (match !== undefined) {
    return Primitive_option.some(match.id);
  } else {
    return;
  }
}
function initializeStateLabelSheet(priceList, priceId, productBarcodeDisplayed, missingProductBarcodeGenerated, priceDisplayed, producerDisplayed, alcoholVolumeDisplayed, designationDisplayed, productCode, labelFormat, printOffset, borderEnabled, sort, param) {
  let priceId$1 = Stdlib_Option.getOr(Stdlib_Option.orElse(priceId, defaultPriceIdFromPriceList(priceList)), Uuid$1.v4());
  return {
    priceList: priceList,
    form: {
      TAG: "LabelSheet",
      _0: {
        submitResult: "NotAsked",
        values: initialValues(priceId$1, productBarcodeDisplayed, missingProductBarcodeGenerated, priceDisplayed, producerDisplayed, alcoholVolumeDisplayed, designationDisplayed, productCode, labelFormat, printOffset, borderEnabled, sort, undefined),
        errorMessages: {}
      }
    }
  };
}
function initializeStateLabelPrint(settingsOnlyOpt, priceList, priceId, productBarcodeDisplayed, missingProductBarcodeGenerated, priceDisplayed, producerDisplayed, alcoholVolumeDisplayed, designationDisplayed, productCode, labelFormat, param) {
  let settingsOnly = settingsOnlyOpt !== undefined ? Primitive_option.valFromOption(settingsOnlyOpt) : undefined;
  let priceId$1 = Stdlib_Option.getOr(Stdlib_Option.orElse(priceId, defaultPriceIdFromPriceList(priceList)), Uuid$1.v4());
  return {
    priceList: priceList,
    form: {
      TAG: "LabelPrint",
      _0: {
        settingsOnly: settingsOnly,
        submitResult: "NotAsked",
        values: initialValues$1(priceId$1, productBarcodeDisplayed, missingProductBarcodeGenerated, priceDisplayed, producerDisplayed, alcoholVolumeDisplayed, designationDisplayed, productCode, labelFormat, undefined),
        errorMessages: {}
      }
    }
  };
}
function toLabelSheetFormValues(values) {
  let match = initialValues(values.priceId, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  return {
    priceId: values.priceId,
    productBarcodeDisplayed: values.productBarcodeDisplayed,
    missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
    priceDisplayed: values.priceDisplayed,
    producerDisplayed: values.producerDisplayed,
    alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
    designationDisplayed: values.designationDisplayed,
    productCode: values.productCode,
    labelFormat: match.labelFormat,
    printOffset: match.printOffset,
    borderEnabled: match.borderEnabled,
    sort: match.sort,
    productValues: values.productValues
  };
}
function toLabelPrintFormValues(values) {
  let match = initialValues$1(values.priceId, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  return {
    priceId: values.priceId,
    productBarcodeDisplayed: values.productBarcodeDisplayed,
    missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
    priceDisplayed: match.priceDisplayed,
    producerDisplayed: match.producerDisplayed,
    alcoholVolumeDisplayed: match.alcoholVolumeDisplayed,
    designationDisplayed: match.designationDisplayed,
    productCode: values.productCode,
    labelFormat: match.labelFormat,
    productValues: values.productValues
  };
}
function reducer(state, action) {
  if (typeof action !== "object") {
    let form = state.form;
    if (form.TAG === "LabelSheet") {
      return initializeStateLabelPrint(undefined, state.priceList, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    }
    let form$1 = form._0;
    return {
      priceList: state.priceList,
      form: {
        TAG: "LabelPrint",
        _0: {
          settingsOnly: form$1.settingsOnly,
          submitResult: "Loading",
          values: form$1.values,
          errorMessages: form$1.errorMessages
        }
      }
    };
  }
  switch (action.TAG) {
    case "LabelSheetEdited":
      let values = action._0;
      let match = state.form;
      if (match.TAG !== "LabelSheet") {
        return initializeStateLabelSheet(state.priceList, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      }
      let prevValues = match._0.values;
      let nextValues_priceId = values.priceId;
      let nextValues_productBarcodeDisplayed = values.missingProductBarcodeGenerated && !prevValues.productBarcodeDisplayed ? true : values.productBarcodeDisplayed;
      let nextValues_missingProductBarcodeGenerated = !values.productBarcodeDisplayed && prevValues.missingProductBarcodeGenerated ? false : values.missingProductBarcodeGenerated;
      let nextValues_priceDisplayed = values.priceDisplayed;
      let nextValues_producerDisplayed = values.producerDisplayed;
      let nextValues_alcoholVolumeDisplayed = values.alcoholVolumeDisplayed;
      let nextValues_designationDisplayed = values.designationDisplayed;
      let nextValues_productCode = values.productCode;
      let nextValues_labelFormat = values.labelFormat;
      let nextValues_printOffset = values.printOffset;
      let nextValues_borderEnabled = values.borderEnabled;
      let nextValues_sort = values.sort;
      let nextValues_productValues = values.productValues;
      let nextValues = {
        priceId: nextValues_priceId,
        productBarcodeDisplayed: nextValues_productBarcodeDisplayed,
        missingProductBarcodeGenerated: nextValues_missingProductBarcodeGenerated,
        priceDisplayed: nextValues_priceDisplayed,
        producerDisplayed: nextValues_producerDisplayed,
        alcoholVolumeDisplayed: nextValues_alcoholVolumeDisplayed,
        designationDisplayed: nextValues_designationDisplayed,
        productCode: nextValues_productCode,
        labelFormat: nextValues_labelFormat,
        printOffset: nextValues_printOffset,
        borderEnabled: nextValues_borderEnabled,
        sort: nextValues_sort,
        productValues: nextValues_productValues
      };
      return {
        priceList: state.priceList,
        form: {
          TAG: "LabelSheet",
          _0: {
            submitResult: "NotAsked",
            values: nextValues,
            errorMessages: errorMessagesFromValues(nextValues)
          }
        }
      };
    case "LabelSheetProductsUpdated":
      let match$1 = state.form;
      if (match$1.TAG !== "LabelSheet") {
        return state;
      }
      let match$2 = match$1._0;
      let prevValues$1 = match$2.values;
      let nextValues_priceId$1 = prevValues$1.priceId;
      let nextValues_productBarcodeDisplayed$1 = prevValues$1.productBarcodeDisplayed;
      let nextValues_missingProductBarcodeGenerated$1 = prevValues$1.missingProductBarcodeGenerated;
      let nextValues_priceDisplayed$1 = prevValues$1.priceDisplayed;
      let nextValues_producerDisplayed$1 = prevValues$1.producerDisplayed;
      let nextValues_alcoholVolumeDisplayed$1 = prevValues$1.alcoholVolumeDisplayed;
      let nextValues_designationDisplayed$1 = prevValues$1.designationDisplayed;
      let nextValues_productCode$1 = prevValues$1.productCode;
      let nextValues_labelFormat$1 = prevValues$1.labelFormat;
      let nextValues_printOffset$1 = prevValues$1.printOffset;
      let nextValues_borderEnabled$1 = prevValues$1.borderEnabled;
      let nextValues_sort$1 = prevValues$1.sort;
      let nextValues_productValues$1 = action._0(prevValues$1.productValues);
      let nextValues$1 = {
        priceId: nextValues_priceId$1,
        productBarcodeDisplayed: nextValues_productBarcodeDisplayed$1,
        missingProductBarcodeGenerated: nextValues_missingProductBarcodeGenerated$1,
        priceDisplayed: nextValues_priceDisplayed$1,
        producerDisplayed: nextValues_producerDisplayed$1,
        alcoholVolumeDisplayed: nextValues_alcoholVolumeDisplayed$1,
        designationDisplayed: nextValues_designationDisplayed$1,
        productCode: nextValues_productCode$1,
        labelFormat: nextValues_labelFormat$1,
        printOffset: nextValues_printOffset$1,
        borderEnabled: nextValues_borderEnabled$1,
        sort: nextValues_sort$1,
        productValues: nextValues_productValues$1
      };
      return {
        priceList: state.priceList,
        form: {
          TAG: "LabelSheet",
          _0: {
            submitResult: match$2.submitResult,
            values: nextValues$1,
            errorMessages: errorMessagesFromValues(nextValues$1)
          }
        }
      };
    case "LabelPrintEdited":
      let values$1 = action._0;
      let match$3 = state.form;
      if (match$3.TAG === "LabelSheet") {
        return initializeStateLabelPrint(undefined, state.priceList, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      }
      let match$4 = match$3._0;
      let prevValues$2 = match$4.values;
      let nextValues_priceId$2 = values$1.priceId;
      let nextValues_productBarcodeDisplayed$2 = values$1.missingProductBarcodeGenerated && !prevValues$2.productBarcodeDisplayed ? true : values$1.productBarcodeDisplayed;
      let nextValues_missingProductBarcodeGenerated$2 = !values$1.productBarcodeDisplayed && prevValues$2.missingProductBarcodeGenerated ? false : values$1.missingProductBarcodeGenerated;
      let nextValues_priceDisplayed$2 = values$1.priceDisplayed;
      let nextValues_producerDisplayed$2 = values$1.producerDisplayed;
      let nextValues_alcoholVolumeDisplayed$2 = values$1.alcoholVolumeDisplayed;
      let nextValues_designationDisplayed$2 = values$1.designationDisplayed;
      let nextValues_productCode$2 = values$1.productCode;
      let nextValues_labelFormat$2 = values$1.labelFormat;
      let nextValues_productValues$2 = values$1.productValues;
      let nextValues$2 = {
        priceId: nextValues_priceId$2,
        productBarcodeDisplayed: nextValues_productBarcodeDisplayed$2,
        missingProductBarcodeGenerated: nextValues_missingProductBarcodeGenerated$2,
        priceDisplayed: nextValues_priceDisplayed$2,
        producerDisplayed: nextValues_producerDisplayed$2,
        alcoholVolumeDisplayed: nextValues_alcoholVolumeDisplayed$2,
        designationDisplayed: nextValues_designationDisplayed$2,
        productCode: nextValues_productCode$2,
        labelFormat: nextValues_labelFormat$2,
        productValues: nextValues_productValues$2
      };
      return {
        priceList: state.priceList,
        form: {
          TAG: "LabelPrint",
          _0: {
            settingsOnly: match$4.settingsOnly,
            submitResult: "NotAsked",
            values: nextValues$2,
            errorMessages: errorMessagesFromValues$1(nextValues$2)
          }
        }
      };
    case "LabelPrintProductsUpdated":
      let match$5 = state.form;
      if (match$5.TAG === "LabelSheet") {
        return state;
      }
      let match$6 = match$5._0;
      let prevValues$3 = match$6.values;
      let nextValues_priceId$3 = prevValues$3.priceId;
      let nextValues_productBarcodeDisplayed$3 = prevValues$3.productBarcodeDisplayed;
      let nextValues_missingProductBarcodeGenerated$3 = prevValues$3.missingProductBarcodeGenerated;
      let nextValues_priceDisplayed$3 = prevValues$3.priceDisplayed;
      let nextValues_producerDisplayed$3 = prevValues$3.producerDisplayed;
      let nextValues_alcoholVolumeDisplayed$3 = prevValues$3.alcoholVolumeDisplayed;
      let nextValues_designationDisplayed$3 = prevValues$3.designationDisplayed;
      let nextValues_productCode$3 = prevValues$3.productCode;
      let nextValues_labelFormat$3 = prevValues$3.labelFormat;
      let nextValues_productValues$3 = action._0(prevValues$3.productValues);
      let nextValues$3 = {
        priceId: nextValues_priceId$3,
        productBarcodeDisplayed: nextValues_productBarcodeDisplayed$3,
        missingProductBarcodeGenerated: nextValues_missingProductBarcodeGenerated$3,
        priceDisplayed: nextValues_priceDisplayed$3,
        producerDisplayed: nextValues_producerDisplayed$3,
        alcoholVolumeDisplayed: nextValues_alcoholVolumeDisplayed$3,
        designationDisplayed: nextValues_designationDisplayed$3,
        productCode: nextValues_productCode$3,
        labelFormat: nextValues_labelFormat$3,
        productValues: nextValues_productValues$3
      };
      return {
        priceList: state.priceList,
        form: {
          TAG: "LabelPrint",
          _0: {
            settingsOnly: match$6.settingsOnly,
            submitResult: match$6.submitResult,
            values: nextValues$3,
            errorMessages: errorMessagesFromValues$1(nextValues$3)
          }
        }
      };
    case "GenerateLabelsSubmitted":
      let request = action._0;
      let form$2 = state.form;
      if (form$2.TAG !== "LabelSheet") {
        return initializeStateLabelSheet(state.priceList, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      }
      let form$3 = form$2._0;
      let validatedState_priceList = state.priceList;
      let validatedState_form = {
        TAG: "LabelSheet",
        _0: {
          submitResult: request,
          values: form$3.values,
          errorMessages: errorMessagesFromValues(form$3.values)
        }
      };
      let validatedState = {
        priceList: validatedState_priceList,
        form: validatedState_form
      };
      let request$1 = isErrored(validatedState) ? {
        TAG: "Done",
        _0: {
          TAG: "Error",
          _0: I18n.t(validationErrorText)
        }
      } : request;
      return {
        priceList: state.priceList,
        form: {
          TAG: "LabelSheet",
          _0: {
            submitResult: request$1,
            values: form$3.values,
            errorMessages: errorMessagesFromValues(form$3.values)
          }
        }
      };
    case "PrintLabelsSubmitted":
      let request$2 = action._0;
      let form$4 = state.form;
      if (form$4.TAG === "LabelSheet") {
        return initializeStateLabelPrint(undefined, state.priceList, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      }
      let form$5 = form$4._0;
      let validatedState_priceList$1 = state.priceList;
      let validatedState_form$1 = {
        TAG: "LabelPrint",
        _0: {
          settingsOnly: form$5.settingsOnly,
          submitResult: request$2,
          values: form$5.values,
          errorMessages: errorMessagesFromValues$1(form$5.values)
        }
      };
      let validatedState$1 = {
        priceList: validatedState_priceList$1,
        form: validatedState_form$1
      };
      let request$3 = isErrored(validatedState$1) ? {
        TAG: "Done",
        _0: {
          TAG: "Error",
          _0: I18n.t(validationErrorText)
        }
      } : request$2;
      return {
        priceList: state.priceList,
        form: {
          TAG: "LabelPrint",
          _0: {
            settingsOnly: form$5.settingsOnly,
            submitResult: request$3,
            values: form$5.values,
            errorMessages: errorMessagesFromValues$1(form$5.values)
          }
        }
      };
  }
}
let CatalogLabelCreateReducer = {
  validationErrorText: validationErrorText,
  isErrored: isErrored,
  isPrintMode: isPrintMode,
  isSettingsOnlyMode: isSettingsOnlyMode,
  defaultPriceIdFromPriceList: defaultPriceIdFromPriceList,
  initializeStateLabelSheet: initializeStateLabelSheet,
  initializeStateLabelPrint: initializeStateLabelPrint,
  toLabelSheetFormValues: toLabelSheetFormValues,
  toLabelPrintFormValues: toLabelPrintFormValues,
  reducer: reducer
};
let make = React.memo(props => {
  let values = props.values;
  let productValues = values.productValues;
  let onChange = props.onChange;
  let hasProductsPicked;
  hasProductsPicked = typeof productValues !== "object" ? true : productValues._0.length !== 0;
  return JsxRuntime.jsxs(Card.make, {
    children: [JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsx(Select.make, {
        label: I18n.t("Price list"),
        preset: {
          NAME: "inputField",
          VAL: {
            required: false
          }
        },
        disabled: hasProductsPicked,
        sections: [{
          items: props.priceList.map(item => ({
            TAG: "Option",
            key: item.id,
            label: item.name,
            value: item.id
          }))
        }],
        value: {
          TAG: "Single",
          _0: values.priceId
        },
        onChange: change => {
          if (change.TAG === "Single") {
            return onChange({
              priceId: change._0,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              printOffset: values.printOffset,
              borderEnabled: values.borderEnabled,
              sort: values.sort,
              productValues: values.productValues
            });
          }
        }
      }),
      placement: "end",
      offset: 4,
      crossOffset: 11,
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Modification of the price list is only allowed when there is no selected products.")
      }),
      disabled: !hasProductsPicked,
      delay: 0
    }), JsxRuntime.jsx(InfoBlock.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display barcode"),
            required: false,
            value: values.productBarcodeDisplayed,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: value,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              printOffset: values.printOffset,
              borderEnabled: values.borderEnabled,
              sort: values.sort,
              productValues: values.productValues
            })
          }), JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Automatically generate missing barcodes"),
            required: false,
            value: values.missingProductBarcodeGenerated,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: value,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              printOffset: values.printOffset,
              borderEnabled: values.borderEnabled,
              sort: values.sort,
              productValues: values.productValues
            })
          }), JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display retail price"),
            required: false,
            value: values.priceDisplayed,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: value,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              printOffset: values.printOffset,
              borderEnabled: values.borderEnabled,
              sort: values.sort,
              productValues: values.productValues
            })
          }), JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display producer"),
            required: false,
            value: values.producerDisplayed,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: value,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              printOffset: values.printOffset,
              borderEnabled: values.borderEnabled,
              sort: values.sort,
              productValues: values.productValues
            })
          }), JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display alcohol volume"),
            required: false,
            value: values.alcoholVolumeDisplayed,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: value,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              printOffset: values.printOffset,
              borderEnabled: values.borderEnabled,
              sort: values.sort,
              productValues: values.productValues
            })
          }), JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display designation"),
            required: false,
            value: values.designationDisplayed,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: value,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              printOffset: values.printOffset,
              borderEnabled: values.borderEnabled,
              sort: values.sort,
              productValues: values.productValues
            })
          })],
          space: "small"
        }), JsxRuntime.jsx(InputRadioGroupField.make, {
          label: I18n.t("Additional product code"),
          value: values.productCode,
          required: false,
          onChange: value => onChange({
            priceId: values.priceId,
            productBarcodeDisplayed: values.productBarcodeDisplayed,
            missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
            priceDisplayed: values.priceDisplayed,
            producerDisplayed: values.producerDisplayed,
            alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
            designationDisplayed: values.designationDisplayed,
            productCode: value,
            labelFormat: values.labelFormat,
            printOffset: values.printOffset,
            borderEnabled: values.borderEnabled,
            sort: values.sort,
            productValues: values.productValues
          }),
          options: CatalogLabel.ProductCode.values,
          optionToText: CatalogLabel.ProductCode.toLabel
        })],
        space: "medium"
      }),
      title: I18n.t("Options")
    })],
    title: I18n.t("Label information"),
    grow: true
  });
});
let LabelSheet = {
  make: make
};
let make$1 = React.memo(props => {
  let values = props.values;
  let productValues = values.productValues;
  let onChange = props.onChange;
  let hasProductsPicked;
  hasProductsPicked = typeof productValues !== "object" ? false : productValues._0.length !== 0;
  return JsxRuntime.jsxs(Card.make, {
    children: [JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsx(Select.make, {
        label: I18n.t("Price list"),
        preset: {
          NAME: "inputField",
          VAL: {
            required: false
          }
        },
        disabled: hasProductsPicked,
        sections: [{
          items: props.priceList.map(item => ({
            TAG: "Option",
            key: item.id,
            label: item.name,
            value: item.id
          }))
        }],
        value: {
          TAG: "Single",
          _0: values.priceId
        },
        onChange: change => {
          if (change.TAG === "Single") {
            return onChange({
              priceId: change._0,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              productValues: values.productValues
            });
          }
        }
      }),
      placement: "end",
      offset: 4,
      crossOffset: 11,
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Modification of the price list is only allowed when there is no selected products.")
      }),
      disabled: !hasProductsPicked,
      delay: 0
    }), JsxRuntime.jsx(InfoBlock.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display barcode"),
            required: false,
            value: values.productBarcodeDisplayed,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: value,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              productValues: values.productValues
            })
          }), JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Automatically generate missing barcodes"),
            required: false,
            value: values.missingProductBarcodeGenerated,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: value,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              productValues: values.productValues
            })
          }), JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display retail price"),
            required: false,
            value: values.priceDisplayed,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: value,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              productValues: values.productValues
            })
          }), JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display producer"),
            required: false,
            value: values.producerDisplayed,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: value,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              productValues: values.productValues
            })
          }), JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display alcohol volume"),
            required: false,
            value: values.alcoholVolumeDisplayed,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: value,
              designationDisplayed: values.designationDisplayed,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              productValues: values.productValues
            })
          }), JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display designation"),
            required: false,
            value: values.designationDisplayed,
            onChange: value => onChange({
              priceId: values.priceId,
              productBarcodeDisplayed: values.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
              priceDisplayed: values.priceDisplayed,
              producerDisplayed: values.producerDisplayed,
              alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
              designationDisplayed: value,
              productCode: values.productCode,
              labelFormat: values.labelFormat,
              productValues: values.productValues
            })
          })],
          space: "small"
        }), JsxRuntime.jsx(InputRadioGroupField.make, {
          label: I18n.t("Additional product code"),
          value: values.productCode,
          required: false,
          onChange: value => onChange({
            priceId: values.priceId,
            productBarcodeDisplayed: values.productBarcodeDisplayed,
            missingProductBarcodeGenerated: values.missingProductBarcodeGenerated,
            priceDisplayed: values.priceDisplayed,
            producerDisplayed: values.producerDisplayed,
            alcoholVolumeDisplayed: values.alcoholVolumeDisplayed,
            designationDisplayed: values.designationDisplayed,
            productCode: value,
            labelFormat: values.labelFormat,
            productValues: values.productValues
          }),
          options: CatalogLabel.ProductCode.values,
          optionToText: CatalogLabel.ProductCode.toLabel
        })],
        space: "medium"
      }),
      title: I18n.t("Options")
    })],
    title: I18n.t("Label information"),
    grow: true
  });
});
let LabelPrint = {
  make: make$1
};
let CatalogLabelCreateInformationCard = {
  LabelSheet: LabelSheet,
  LabelPrint: LabelPrint
};
let values = ["Label31x22", "Grid21", "Grid64"];
function isStarFormat(value) {
  switch (value) {
    case "Grid21":
    case "Grid64":
      return false;
    case "Label31x22":
    case "Label57x19":
      return true;
  }
}
function toLabel(value) {
  switch (value) {
    case "Grid21":
      return CatalogLabel.Sheet.LabelFormat.toLabel("Grid21");
    case "Grid64":
      return CatalogLabel.Sheet.LabelFormat.toLabel("Grid64");
    case "Label31x22":
      return CatalogLabel.Print.LabelFormat.toLabel("Label31x22");
    case "Label57x19":
      return CatalogLabel.Print.LabelFormat.toLabel("Label57x19");
  }
}
let GlobalLabelFormat = {
  values: values,
  isStarFormat: isStarFormat,
  toLabel: toLabel
};
let make$2 = React.memo(props => {
  let values$1 = props.values;
  let labelFormat = values$1.labelFormat;
  let onChangeLabelFormat = props.onChangeLabelFormat;
  let onChange = props.onChange;
  let printerStatus = props.printerStatus;
  let maxPrintOffset = CatalogLabel.Sheet.LabelFormat.toMaxOffset(labelFormat);
  let labelFormat$1;
  labelFormat$1 = labelFormat === "Grid21" ? "Grid21" : "Grid64";
  let renderTemplateSelectionItemContent = React.useCallback(param => {
    let item = param.item;
    if (item.TAG !== "Option") {
      return null;
    }
    let starFormat = isStarFormat(item.value);
    let tmp;
    tmp = printerStatus.TAG === "Ok" ? starFormat ? JsxRuntime.jsx(TooltipIcon.make, {
      children: JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Format suitable for Star label printers.")
      }),
      variation: "info"
    }) : null : starFormat ? JsxRuntime.jsx(TooltipIcon.make, {
      children: JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("No StarPrinter printers registered in this shop.")
      }),
      variation: "alert"
    }) : null;
    return JsxRuntime.jsxs(Inline.make, {
      children: [item.label, tmp],
      space: "xsmall"
    });
  }, [printerStatus]);
  let items = values.map(value => ({
    TAG: "Option",
    key: toLabel(value),
    label: toLabel(value),
    value: value,
    disabled: isStarFormat(value) && Stdlib_Result.isError(printerStatus)
  }));
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(Select.make, {
          label: I18n.t("Label template"),
          preset: {
            NAME: "inputField",
            VAL: {
              required: false
            }
          },
          renderItem: renderTemplateSelectionItemContent,
          sections: [{
            items: items
          }],
          value: {
            TAG: "Single",
            _0: labelFormat$1
          },
          onChange: change => {
            if (change.TAG === "Single") {
              return onChangeLabelFormat(change._0);
            }
          }
        }), JsxRuntime.jsx(InputNumberField.make, {
          value: values$1.printOffset,
          minValue: 1,
          maxValue: maxPrintOffset,
          precision: 0,
          label: I18n.t("Offset of the first printed label"),
          errorMessage: props.printOffsetErrorMessage,
          required: false,
          onChange: value => onChange({
            priceId: values$1.priceId,
            productBarcodeDisplayed: values$1.productBarcodeDisplayed,
            missingProductBarcodeGenerated: values$1.missingProductBarcodeGenerated,
            priceDisplayed: values$1.priceDisplayed,
            producerDisplayed: values$1.producerDisplayed,
            alcoholVolumeDisplayed: values$1.alcoholVolumeDisplayed,
            designationDisplayed: values$1.designationDisplayed,
            productCode: values$1.productCode,
            labelFormat: values$1.labelFormat,
            printOffset: value | 0,
            borderEnabled: values$1.borderEnabled,
            sort: values$1.sort,
            productValues: values$1.productValues
          })
        })],
        space: "medium"
      }), JsxRuntime.jsx(InfoBlock.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t("Display border"),
            required: false,
            value: values$1.borderEnabled,
            onChange: value => onChange({
              priceId: values$1.priceId,
              productBarcodeDisplayed: values$1.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values$1.missingProductBarcodeGenerated,
              priceDisplayed: values$1.priceDisplayed,
              producerDisplayed: values$1.producerDisplayed,
              alcoholVolumeDisplayed: values$1.alcoholVolumeDisplayed,
              designationDisplayed: values$1.designationDisplayed,
              productCode: values$1.productCode,
              labelFormat: values$1.labelFormat,
              printOffset: values$1.printOffset,
              borderEnabled: value,
              sort: values$1.sort,
              productValues: values$1.productValues
            })
          }), JsxRuntime.jsx(InputRadioGroupField.make, {
            label: I18n.t("Sorting labels"),
            value: values$1.sort,
            required: false,
            onChange: value => onChange({
              priceId: values$1.priceId,
              productBarcodeDisplayed: values$1.productBarcodeDisplayed,
              missingProductBarcodeGenerated: values$1.missingProductBarcodeGenerated,
              priceDisplayed: values$1.priceDisplayed,
              producerDisplayed: values$1.producerDisplayed,
              alcoholVolumeDisplayed: values$1.alcoholVolumeDisplayed,
              designationDisplayed: values$1.designationDisplayed,
              productCode: values$1.productCode,
              labelFormat: values$1.labelFormat,
              printOffset: values$1.printOffset,
              borderEnabled: values$1.borderEnabled,
              sort: value,
              productValues: values$1.productValues
            }),
            options: CatalogLabel.Sheet.LabelSort.values,
            optionToText: CatalogLabel.Sheet.LabelSort.toLabel
          }), JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("The printing is done on an A4 laser printer.") + "\n" + I18n.t("If required, you can order adhesive label sheets or rolls online."),
              variation: "normal",
              size: "small"
            }), JsxRuntime.jsx(TextAction.make, {
              text: I18n.t("Order label holders online."),
              highlighted: true,
              onPress: () => HelpCenter.showArticle(HelpCenter.orderLabelSheets)
            })],
            space: "normal"
          })],
          space: "medium"
        }),
        title: I18n.t("Options")
      })],
      space: "xlarge"
    }),
    title: I18n.t("Print setup"),
    grow: true
  });
});
let LabelSheet$1 = {
  make: make$2
};
let make$3 = React.memo(props => {
  let onChangeLabelFormat = props.onChangeLabelFormat;
  let settingsOnly = props.settingsOnly;
  let printerStatus = props.printerStatus;
  let labelFormat;
  labelFormat = props.values.labelFormat === "Label31x22" ? "Label31x22" : "Label57x19";
  let renderTemplateSelectionItemContent = React.useCallback(param => {
    let item = param.item;
    if (item.TAG !== "Option") {
      return null;
    }
    let starFormat = isStarFormat(item.value);
    let tmp;
    tmp = printerStatus.TAG === "Ok" ? starFormat ? JsxRuntime.jsx(TooltipIcon.make, {
      children: JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Format suitable for Star label printers.")
      }),
      variation: "info"
    }) : null : starFormat ? JsxRuntime.jsx(TooltipIcon.make, {
      children: JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("No StarPrinter printers registered in this shop.")
      }),
      variation: "alert"
    }) : null;
    return JsxRuntime.jsxs(Inline.make, {
      children: [item.label, tmp],
      space: "xsmall"
    });
  }, [printerStatus]);
  let items = values.filter(value => {
    if (settingsOnly) {
      if (settingsOnly) {
        return isStarFormat(value);
      } else {
        return false;
      }
    } else {
      return true;
    }
  }).map(value => ({
    TAG: "Option",
    key: toLabel(value),
    label: toLabel(value),
    value: value,
    disabled: isStarFormat(value) && Stdlib_Result.isError(printerStatus)
  }));
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(Select.make, {
        label: I18n.t("Label template"),
        preset: {
          NAME: "inputField",
          VAL: {
            required: false
          }
        },
        renderItem: renderTemplateSelectionItemContent,
        sections: [{
          items: items
        }],
        value: {
          TAG: "Single",
          _0: labelFormat
        },
        onChange: change => {
          if (change.TAG === "Single") {
            return onChangeLabelFormat(change._0);
          }
        }
      }), JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Printing is done on a Star mC-Label3 thermal connected printer."),
              variation: "normal",
              size: "small"
            }), JsxRuntime.jsx(TextAction.make, {
              text: I18n.t("Find out more about the printer."),
              highlighted: true,
              onPress: () => HelpCenter.showArticle(HelpCenter.getLabelPrintFeature)
            })],
            space: "xsmall"
          }), JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("If required, you can order adhesive label sheets or rolls online.") + "\n",
              variation: "normal",
              size: "small"
            }), JsxRuntime.jsx(TextAction.make, {
              text: I18n.t("Order label holders online."),
              highlighted: true,
              onPress: () => HelpCenter.showArticle(HelpCenter.orderLabelSheets)
            })],
            space: "xsmall"
          })],
          space: "medium"
        }),
        spaceTop: "small"
      })],
      space: "medium"
    }),
    title: I18n.t("Print setup"),
    grow: true
  });
});
let LabelPrint$1 = {
  make: make$3
};
let CatalogLabelCreatePrintSettingsCard = {
  GlobalLabelFormat: GlobalLabelFormat,
  LabelSheet: LabelSheet$1,
  LabelPrint: LabelPrint$1
};
let style = {
  backgroundColor: "#f8f8fb",
  borderBottomColor: "#e7e7ee",
  borderBottomStyle: "solid",
  borderBottomWidth: "1px",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  padding: "23px 0"
};
let make$4 = React.memo(props => {
  let errorMessage = props.errorMessage;
  let newrecord = {
    ...{
      style: {
        backgroundColor: "#f8f8fb",
        borderBottomColor: "#e7e7ee",
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        padding: "23px 0"
      }
    }
  };
  return JsxRuntime.jsxs("div", (newrecord.children = [JsxRuntime.jsx(TextStyle.make, {
    children: props.message,
    variation: "normal",
    size: "small"
  }), errorMessage !== undefined ? JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(TextStyle.make, {
      children: errorMessage,
      variation: "negative",
      size: "xsmall"
    }),
    spaceTop: "xsmall"
  }) : null], newrecord));
});
let TableEmptyState = {
  style: style,
  make: make$4
};
function reducer$1(state, action) {
  if (typeof action !== "object") {
    if (action === "Reset") {
      return {
        TAG: "Picked",
        _0: []
      };
    } else {
      return "All";
    }
  }
  switch (action.TAG) {
    case "RowsProductsAdded":
      if (typeof state !== "object") {
        return "All";
      }
      let currentProducts = state._0;
      let filteredAddedProducts = action._0.filter(addedProduct => !currentProducts.some(currentProduct => currentProduct.productVariantId === addedProduct.productVariantId));
      return {
        TAG: "Picked",
        _0: Belt_Array.concatMany([currentProducts, filteredAddedProducts])
      };
    case "RowProductUpdated":
      let printingQuantity = action._1;
      let updatedProductId = action._0;
      if (typeof state !== "object") {
        return "All";
      }
      let updatedProducts = state._0.map(currentProduct => {
        if (currentProduct.productVariantId === updatedProductId) {
          return {
            productVariantId: currentProduct.productVariantId,
            printingQuantity: printingQuantity,
            productInformation: currentProduct.productInformation
          };
        } else {
          return currentProduct;
        }
      });
      return {
        TAG: "Picked",
        _0: updatedProducts
      };
    case "RowProductRemoved":
      let removedProductId = action._0;
      if (typeof state !== "object") {
        return "All";
      }
      let updatedProducts$1 = state._0.filter(currentProduct => currentProduct.productVariantId !== removedProductId);
      return {
        TAG: "Picked",
        _0: updatedProducts$1
      };
  }
}
function makeTableColumns(dispatch, hasProductsAllPicked) {
  return [{
    key: "line",
    name: I18n.t("Line"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 65
      },
      width: {
        NAME: "px",
        VAL: 65
      }
    },
    render: param => {
      let formattedLineNumber = (param.index + 1 | 0).toString().padStart(4, "0");
      return JsxRuntime.jsx(TextStyle.make, {
        children: formattedLineNumber,
        variation: "normal",
        size: "xsmall"
      });
    }
  }, {
    key: "reference",
    name: I18n.t("Product"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 250
      },
      width: {
        NAME: "px",
        VAL: 450
      }
    },
    render: param => {
      let match = param.data;
      let match$1 = match.productInformation;
      return JsxRuntime.jsx(LegacyProductReferenceTableCell.make, {
        id: match.productVariantId,
        name: match$1.name,
        description: match$1.description,
        openNewTab: true
      });
    }
  }, {
    key: "printing-quantity",
    name: I18n.t("Copies"),
    layout: {
      hidden: hasProductsAllPicked,
      width: {
        NAME: "px",
        VAL: 80
      }
    },
    render: param => {
      let match = param.data;
      let productVariantId = match.productVariantId;
      return JsxRuntime.jsx(InputNumberField.make, {
        value: match.printingQuantity,
        minValue: 1,
        precision: 0,
        onChange: value => dispatch({
          TAG: "RowProductUpdated",
          _0: productVariantId,
          _1: value | 0
        })
      });
    }
  }, {
    key: "actions",
    layout: {
      alignX: "flexEnd"
    },
    render: param => {
      let productVariantId = param.data.productVariantId;
      return JsxRuntime.jsx(Button.make, {
        shape: "pill",
        icon: "delete",
        onPress: () => dispatch(hasProductsAllPicked ? "Reset" : {
          TAG: "RowProductRemoved",
          _0: productVariantId
        })
      });
    }
  }];
}
let make$5 = React.memo(props => {
  let onChange = props.onChange;
  let products = props.products;
  let productsTotalCount = props.productsTotalCount;
  let printMode = props.printMode;
  let match = React.useState(() => false);
  let setPickerOpened = match[1];
  let dispatch = action => onChange(prevProducts => reducer$1(prevProducts, action));
  React.useEffect(() => {
    if (printMode && typeof products !== "object") {
      onChange(prevProducts => ({
        TAG: "Picked",
        _0: []
      }));
    }
  }, [printMode]);
  let hasProductsAllPicked;
  hasProductsAllPicked = typeof products !== "object";
  let columns = makeTableColumns(dispatch, hasProductsAllPicked);
  let onPickProducts = products => {
    let rows = products.map(product => ({
      productVariantId: product.id,
      printingQuantity: 1,
      productInformation: {
        name: product.formattedName,
        description: CatalogProduct.Information.formatDescription(product.productKind, product.information, undefined, undefined, undefined, undefined),
        internalCode: product.information.internalCode,
        stockKeepingUnit: product.information.sku
      }
    }));
    let action = {
      TAG: "RowsProductsAdded",
      _0: rows
    };
    onChange(prevProducts => reducer$1(prevProducts, action));
  };
  let tooManyProductsPicked = productsTotalCount > 1000;
  let pickAllProductsButtonDisabled = printMode || tooManyProductsPicked || hasProductsAllPicked;
  let resetButtonDisabled;
  resetButtonDisabled = typeof products !== "object" ? false : products._0.length === 0;
  let tableProductsRows;
  tableProductsRows = typeof products !== "object" ? [{
    productVariantId: "all",
    printingQuantity: 0,
    productInformation: {
      name: productsTotalCount.toString() + " " + I18n.t("added products"),
      description: I18n.t("All non-archived catalog products"),
      internalCode: undefined,
      stockKeepingUnit: undefined
    }
  }] : products._0;
  let pickerModalProductsDisabledIds;
  pickerModalProductsDisabledIds = typeof products !== "object" ? [] : products._0.map(row => row.productVariantId);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsxs(Card.make, {
      children: [JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Inline.make, {
          children: [JsxRuntime.jsx(Button.make, {
            label: I18n.t("Search product"),
            variant: {
              NAME: "ghost",
              VAL: {
                bordered: true
              }
            },
            tone: "brand",
            icon: "search",
            onPress: () => setPickerOpened(param => true)
          }), JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(Tooltip.make, {
              children: JsxRuntime.jsx(Button.make, {
                label: I18n.t("Add all products"),
                variant: "subtle",
                disabled: pickAllProductsButtonDisabled,
                icon: "plus_small",
                onPress: () => onChange(prevProducts => "All")
              }),
              placement: "top",
              offset: -10,
              content: JsxRuntime.jsx(Tooltip.Span.make, {
                text: printMode ? I18n.t("This feature only works for PDF sheet of labels generation.") : tooManyProductsPicked ? I18n.t("This feature only works for catalogs\nwith less than 1,000 products") : ""
              }),
              disabled: !printMode && !tooManyProductsPicked,
              grow: true,
              delay: 350,
              closeDelay: 0
            }), JsxRuntime.jsx(Button.make, {
              label: I18n.t("Reset"),
              variant: "subtle",
              disabled: resetButtonDisabled,
              icon: "reset_v2",
              onPress: () => onChange(prevProducts => ({
                TAG: "Picked",
                _0: []
              }))
            })]
          })],
          space: "normal"
        }),
        spaceX: "large",
        spaceBottom: "xlarge"
      }), JsxRuntime.jsx(TableView.make, {
        data: {
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: tableProductsRows
          }
        },
        columns: columns,
        keyExtractor: row => row.productVariantId,
        hideCard: true,
        placeholderEmptyState: JsxRuntime.jsx(make$4, {
          message: printMode ? I18n.t("Add products to print labels") : I18n.t("Add products to generate a PDF sheet of labels"),
          errorMessage: props.errorMessage
        })
      })],
      variation: "table"
    }), JsxRuntime.jsx(CatalogLabelProductsPickerModalTable.make, {
      opened: match[0],
      shopId: props.shopId,
      priceId: props.priceId,
      disabledIds: pickerModalProductsDisabledIds,
      onCommit: onPickProducts,
      onRequestClose: () => setPickerOpened(param => false)
    })]
  });
});
let CatalogLabelCreateProductsCard = {
  TableEmptyState: TableEmptyState,
  reducer: reducer$1,
  makeTableColumns: makeTableColumns,
  make: make$5
};
function formateDetails(productValues, invalidBarcodesVariants) {
  if (typeof productValues !== "object") {
    return invalidBarcodesVariants.map(variant => variant.productName + " - " + variant.name);
  }
  let items = productValues._0;
  return Stdlib_Array.filterMap(invalidBarcodesVariants, variant => {
    let match = items.find(item => item.productVariantId === variant.id);
    if (match === undefined) {
      return;
    }
    let match$1 = match.productInformation;
    let stockKeepingUnit = match$1.stockKeepingUnit;
    let name = match$1.name;
    if (stockKeepingUnit !== undefined) {
      return name + ` (` + stockKeepingUnit + `)`;
    } else {
      return name;
    }
  });
}
let make$6 = React.memo(props => {
  let details = formateDetails(props.productValues, props.invalidBarcodesVariants);
  if (details.length !== 0) {
    return JsxRuntime.jsx(Banner.make, {
      textStatus: {
        TAG: "Warning",
        _0: I18n.t("The label sheet has been generated, some incorrect barcodes cannot be displayed.")
      },
      details: details,
      onRequestClose: props.onRequestClose
    });
  } else {
    return null;
  }
});
let CatalogLabelCreatePageInvalidBarcodesBanner = {
  formateDetails: formateDetails,
  make: make$6
};
let make$7 = React.memo(props => {
  let productsTotalCount = props.productsTotalCount;
  let printerStatus = props.printerStatus;
  let shop = props.shop;
  let match = React.useState(() => {});
  let setNotification = match[1];
  let notification = match[0];
  let match$1 = React.useState(() => {});
  let setInvalidBarcodes = match$1[1];
  let invalidBarcodes = match$1[0];
  let match$2 = React.useReducer(reducer, props.initialState);
  let dispatch = match$2[1];
  let state = match$2[0];
  let navigate = Navigation.useNavigate();
  let url = Navigation.useUrl();
  let encoder = CatalogLabel.StateSettingsUserPreferences.encoder;
  let decoder = CatalogLabel.StateSettingsUserPreferences.decoder;
  let match$3 = UserPreferences.make("catalog-labels-options", encoder, decoder);
  let store = match$3.store;
  let getPriceName = priceId => Stdlib_Option.mapOr(state.priceList.find(price => price.id === priceId), "", price => price.name);
  let match$4 = state.form;
  let values;
  if (match$4.TAG === "LabelSheet") {
    let values$1 = match$4._0.values;
    values = {
      priceId: values$1.priceId,
      priceName: getPriceName(values$1.priceId),
      productBarcodeDisplayed: values$1.productBarcodeDisplayed,
      missingProductBarcodeGenerated: values$1.missingProductBarcodeGenerated,
      priceDisplayed: values$1.priceDisplayed,
      producerDisplayed: values$1.producerDisplayed,
      alcoholVolumeDisplayed: values$1.alcoholVolumeDisplayed,
      designationDisplayed: values$1.designationDisplayed,
      productCode: values$1.productCode,
      labelFormat: {
        TAG: "LabelSheet",
        _0: values$1.labelFormat
      },
      printOffset: values$1.printOffset,
      borderEnabled: values$1.borderEnabled,
      sort: values$1.sort
    };
  } else {
    let match$5 = match$4._0;
    if (match$5.settingsOnly !== undefined) {
      values = undefined;
    } else {
      let values$2 = match$5.values;
      values = {
        priceId: values$2.priceId,
        priceName: getPriceName(values$2.priceId),
        productBarcodeDisplayed: values$2.productBarcodeDisplayed,
        missingProductBarcodeGenerated: values$2.missingProductBarcodeGenerated,
        priceDisplayed: values$2.priceDisplayed,
        producerDisplayed: values$2.producerDisplayed,
        alcoholVolumeDisplayed: values$2.alcoholVolumeDisplayed,
        designationDisplayed: values$2.designationDisplayed,
        productCode: values$2.productCode,
        labelFormat: {
          TAG: "LabelPrint",
          _0: values$2.labelFormat
        },
        printOffset: 1,
        borderEnabled: false,
        sort: "Unsorted"
      };
    }
  }
  let persisted = match$3.usePersistOnChange(values, Stdlib_Option.isNone(values) || isErrored(state), 1250, undefined);
  let initialStateSettingsBanner = props.firstPersistence && !isSettingsOnlyMode(state) ? JsxRuntime.jsx(Banner.make, {
    textStatus: {
      TAG: "Info",
      _0: I18n.t("Don't worry! Print settings are automatically saved on the browser from which you configure them.")
    }
  }) : null;
  let text = persisted ? I18n.t("Settings saved on your web browser, a few moments ago.") : I18n.t("Settings unsaved.");
  let color = persisted ? "#1dbb7a" : "#a2a1b0";
  let persistedSettingsIconTooltip = JsxRuntime.jsx(Offset.make, {
    children: JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsx(LegacyIcon.make, {
        name: "cloud_save",
        fill: color
      }),
      arrowed: false,
      placement: "top start",
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: text
      }),
      closeDelay: 0
    }),
    top: -21,
    left: -7
  });
  React.useEffect(() => {
    let requestBarcodeCompletion = CatalogLabel.BarcodeCompletionRequest.make;
    if (isErrored(state)) {
      return;
    }
    let match = state.form;
    if (match.TAG === "LabelSheet") {
      let match$1 = match._0;
      let values = match$1.values;
      if (AsyncResult.isIdle(match$1.submitResult)) {
        return;
      }
      let requestLabelsGenerating = CatalogLabel.Sheet.LabelsRequest.make;
      let combineSheetRequests = CatalogLabel.Sheet.CombineRequests.make;
      let products = values.productValues;
      let tmp;
      tmp = typeof products !== "object" ? "All" : {
        TAG: "Picked",
        _0: products._0.map(product => ({
          variantId: product.productVariantId,
          repetitions: product.printingQuantity
        }))
      };
      let future = combineSheetRequests(requestBarcodeCompletion, requestLabelsGenerating, tmp, values.priceId, values.missingProductBarcodeGenerated, values.productBarcodeDisplayed, values.priceDisplayed, values.producerDisplayed, values.alcoholVolumeDisplayed, values.designationDisplayed, values.productCode, values.labelFormat, values.printOffset, values.borderEnabled, values.sort, shop.id);
      Future.get(Future.map(future, undefined, result => {
        let tmp;
        if (result.TAG === "Ok") {
          let url = result._0;
          tmp = url !== undefined ? {
            TAG: "Ok",
            _0: url
          } : {
            TAG: "Error",
            _0: Request.serverErrorMessage
          };
        } else {
          tmp = {
            TAG: "Error",
            _0: result._0
          };
        }
        return AsyncResult.done(tmp);
      }), requestResult => dispatch({
        TAG: "GenerateLabelsSubmitted",
        _0: requestResult
      }));
      return () => Future.cancel(future);
    }
    let match$2 = match._0;
    let match$3 = match$2.settingsOnly;
    if (match$3 !== undefined) {
      let tmp$1 = match$2.submitResult;
      if (typeof tmp$1 === "object") {
        return;
      }
      if (tmp$1 !== "Loading") {
        return;
      }
      let values$1 = match$2.values;
      let fromPathname = match$3.fromPathname;
      let editRedirectionQueryString = CatalogRoutes.CatalogLabelQueryString.encode({
        variantIdfromLabelEditSettings: match$3.variantIdFromCatalogRedirection,
        fromPathname: url.pathname
      });
      store({
        priceId: values$1.priceId,
        priceName: getPriceName(values$1.priceId),
        productBarcodeDisplayed: values$1.productBarcodeDisplayed,
        missingProductBarcodeGenerated: values$1.missingProductBarcodeGenerated,
        priceDisplayed: values$1.priceDisplayed,
        producerDisplayed: values$1.producerDisplayed,
        alcoholVolumeDisplayed: values$1.alcoholVolumeDisplayed,
        designationDisplayed: values$1.designationDisplayed,
        productCode: values$1.productCode,
        labelFormat: {
          TAG: "LabelPrint",
          _0: values$1.labelFormat
        },
        printOffset: 1,
        borderEnabled: false,
        sort: "Unsorted"
      });
      if (fromPathname !== url.pathname) {
        navigate(undefined, fromPathname + "?" + editRedirectionQueryString);
      } else {
        navigate(undefined, CatalogRoutes.baseRoute);
      }
      return;
    } else {
      let values$2 = match$2.values;
      if (AsyncResult.isIdle(match$2.submitResult)) {
        return;
      }
      let requestLabelsPrinting = CatalogLabel.Print.LabelsRequest.make;
      let combinePrintRequests = CatalogLabel.Print.CombineRequests.make;
      let products$1 = values$2.productValues;
      let tmp$2;
      tmp$2 = typeof products$1 !== "object" ? "All" : {
        TAG: "Picked",
        _0: products$1._0.map(product => ({
          variantId: product.productVariantId,
          repetitions: product.printingQuantity
        }))
      };
      let future$1 = combinePrintRequests(requestBarcodeCompletion, requestLabelsPrinting, values$2.priceId, getPriceName(values$2.priceId), values$2.productCode, values$2.productBarcodeDisplayed, tmp$2, values$2.labelFormat, values$2.missingProductBarcodeGenerated, values$2.priceDisplayed, values$2.producerDisplayed, values$2.alcoholVolumeDisplayed, values$2.designationDisplayed, shop.id);
      Future.get(Future.map(future$1, undefined, result => {
        let tmp;
        tmp = result.TAG === "Ok" ? {
          TAG: "Ok",
          _0: undefined
        } : {
          TAG: "Error",
          _0: result._0
        };
        return AsyncResult.done(tmp);
      }), requestResult => dispatch({
        TAG: "PrintLabelsSubmitted",
        _0: requestResult
      }));
      return () => Future.cancel(future$1);
    }
  }, [state.form]);
  React.useEffect(() => {
    let match = state.form;
    let exit = 0;
    let errorMessage;
    if (match.TAG === "LabelSheet") {
      let match$1 = match._0.submitResult;
      if (typeof match$1 === "object" && match$1.TAG === "Done") {
        let errorMessage$1 = match$1._0;
        if (errorMessage$1.TAG === "Ok") {
          let match$2 = errorMessage$1._0;
          let invalidBarcodesVariants = match$2.invalidBarcodesVariants;
          if (invalidBarcodesVariants.length !== 0) {
            setInvalidBarcodes(param => invalidBarcodesVariants);
          } else {
            setInvalidBarcodes(param => {});
          }
          Future.get(Future.mapError(Future.mapOk(TriggerDownload.fromUrl(undefined, match$2.url), undefined, () => I18n.t("The label sheet has been successfully generated.")), undefined, () => I18n.t("An issue when attempting downloading the file occurred.")), message => {
            if (invalidBarcodesVariants.length === 0) {
              return setNotification(param => message);
            }
          });
        } else {
          errorMessage = errorMessage$1._0;
          exit = 1;
        }
      }
    } else {
      let match$3 = match._0.submitResult;
      if (typeof match$3 === "object" && match$3.TAG === "Done") {
        let errorMessage$2 = match$3._0;
        if (errorMessage$2.TAG === "Ok") {
          setNotification(param => ({
            TAG: "Ok",
            _0: I18n.t("Label printing is in progress.") + I18n.template(I18n.t("[Monitor printing from your StarPrinter Online account]({{link}})"), {
              link: "https://portal.starprinter.online/Dashboard"
            }, undefined)
          }));
          setInvalidBarcodes(param => {});
        } else {
          errorMessage = errorMessage$2._0;
          exit = 1;
        }
      }
    }
    if (exit === 1) {
      setNotification(param => ({
        TAG: "Error",
        _0: errorMessage
      }));
      setInvalidBarcodes(param => {});
    }
  }, [state.form]);
  React.useEffect(() => {
    let match = state.form;
    if (match.TAG !== "LabelSheet" && printerStatus.TAG !== "Ok") {
      setNotification(param => ({
        TAG: "Error",
        _0: I18n.t("No StarPrinter printers registered in this shop.")
      }));
    }
  }, [printerStatus]);
  let match$6 = state.form;
  let submissionLoading;
  submissionLoading = match$6.TAG === "LabelSheet" ? AsyncResult.isBusy(match$6._0.submitResult) : AsyncResult.isBusy(match$6._0.submitResult);
  let pageTitle = isSettingsOnlyMode(state) ? I18n.t("Set labels settings") : I18n.t("Print the labels");
  let pageSubtitle = props.organisation ? shop.name : undefined;
  let printMode = isPrintMode(state);
  let settingsOnlyMode = isSettingsOnlyMode(state);
  let match$7 = printMode ? settingsOnlyMode ? ["SaveSettingsSubmitted", I18n.t("Commit settings"), "success"] : [{
    TAG: "PrintLabelsSubmitted",
    _0: "Loading"
  }, I18n.t("Print labels"), "brand"] : [{
    TAG: "GenerateLabelsSubmitted",
    _0: "Loading"
  }, I18n.t("Generate labels"), "brand"];
  let action = match$7[0];
  let actionsBar = JsxRuntime.jsx(Button.make, {
    label: match$7[1],
    variant: "solid",
    tone: match$7[2],
    pending: submissionLoading,
    onPress: () => dispatch(action)
  });
  let notificationBanner;
  if (notification !== undefined) {
    let onRequestClose = () => setNotification(param => {});
    notificationBanner = JsxRuntime.jsx(ResourceDetailsPage.NotificationBanner.make, {
      value: notification,
      onRequestClose: onRequestClose
    });
  } else {
    notificationBanner = null;
  }
  let match$8 = state.form;
  let invalidBarcodesBanner;
  if (match$8.TAG === "LabelSheet" && invalidBarcodes !== undefined) {
    let onRequestClose$1 = () => setInvalidBarcodes(param => {});
    invalidBarcodesBanner = JsxRuntime.jsx(make$6, {
      productValues: match$8._0.values.productValues,
      invalidBarcodesVariants: invalidBarcodes,
      onRequestClose: onRequestClose$1
    });
  } else {
    invalidBarcodesBanner = null;
  }
  let match$9 = state.form;
  let tmp;
  tmp = match$9.TAG === "LabelSheet" ? JsxRuntime.jsx(make, {
    priceList: state.priceList,
    values: match$9._0.values,
    onChange: values => dispatch({
      TAG: "LabelSheetEdited",
      _0: values
    })
  }) : JsxRuntime.jsx(make$1, {
    priceList: state.priceList,
    values: match$9._0.values,
    onChange: values => dispatch({
      TAG: "LabelPrintEdited",
      _0: values
    })
  });
  let match$10 = state.form;
  let tmp$1;
  if (match$10.TAG === "LabelSheet") {
    let match$11 = match$10._0;
    let values$3 = match$11.values;
    tmp$1 = JsxRuntime.jsx(make$2, {
      printerStatus: printerStatus,
      values: values$3,
      printOffsetErrorMessage: match$11.errorMessages.printOffset,
      onChange: values => dispatch({
        TAG: "LabelSheetEdited",
        _0: values
      }),
      onChangeLabelFormat: labelFormat => {
        let tmp;
        switch (labelFormat) {
          case "Grid21":
            tmp = {
              TAG: "LabelSheetEdited",
              _0: {
                priceId: values$3.priceId,
                productBarcodeDisplayed: values$3.productBarcodeDisplayed,
                missingProductBarcodeGenerated: values$3.missingProductBarcodeGenerated,
                priceDisplayed: values$3.priceDisplayed,
                producerDisplayed: values$3.producerDisplayed,
                alcoholVolumeDisplayed: values$3.alcoholVolumeDisplayed,
                designationDisplayed: values$3.designationDisplayed,
                productCode: values$3.productCode,
                labelFormat: "Grid21",
                printOffset: values$3.printOffset,
                borderEnabled: values$3.borderEnabled,
                sort: values$3.sort,
                productValues: values$3.productValues
              }
            };
            break;
          case "Grid64":
            tmp = {
              TAG: "LabelSheetEdited",
              _0: {
                priceId: values$3.priceId,
                productBarcodeDisplayed: values$3.productBarcodeDisplayed,
                missingProductBarcodeGenerated: values$3.missingProductBarcodeGenerated,
                priceDisplayed: values$3.priceDisplayed,
                producerDisplayed: values$3.producerDisplayed,
                alcoholVolumeDisplayed: values$3.alcoholVolumeDisplayed,
                designationDisplayed: values$3.designationDisplayed,
                productCode: values$3.productCode,
                labelFormat: "Grid64",
                printOffset: values$3.printOffset,
                borderEnabled: values$3.borderEnabled,
                sort: values$3.sort,
                productValues: values$3.productValues
              }
            };
            break;
          case "Label31x22":
            let init = toLabelPrintFormValues(values$3);
            tmp = {
              TAG: "LabelPrintEdited",
              _0: {
                priceId: init.priceId,
                productBarcodeDisplayed: init.productBarcodeDisplayed,
                missingProductBarcodeGenerated: init.missingProductBarcodeGenerated,
                priceDisplayed: init.priceDisplayed,
                producerDisplayed: init.producerDisplayed,
                alcoholVolumeDisplayed: init.alcoholVolumeDisplayed,
                designationDisplayed: init.designationDisplayed,
                productCode: init.productCode,
                labelFormat: "Label31x22",
                productValues: init.productValues
              }
            };
            break;
          case "Label57x19":
            let init$1 = toLabelPrintFormValues(values$3);
            tmp = {
              TAG: "LabelPrintEdited",
              _0: {
                priceId: init$1.priceId,
                productBarcodeDisplayed: init$1.productBarcodeDisplayed,
                missingProductBarcodeGenerated: init$1.missingProductBarcodeGenerated,
                priceDisplayed: init$1.priceDisplayed,
                producerDisplayed: init$1.producerDisplayed,
                alcoholVolumeDisplayed: init$1.alcoholVolumeDisplayed,
                designationDisplayed: init$1.designationDisplayed,
                productCode: init$1.productCode,
                labelFormat: "Label57x19",
                productValues: init$1.productValues
              }
            };
            break;
        }
        dispatch(tmp);
      }
    });
  } else {
    let match$12 = match$10._0;
    let values$4 = match$12.values;
    tmp$1 = JsxRuntime.jsx(make$3, {
      printerStatus: printerStatus,
      settingsOnly: Stdlib_Option.isSome(match$12.settingsOnly),
      values: values$4,
      onChangeLabelFormat: labelFormat => {
        switch (labelFormat) {
          case "Grid21":
            let init = toLabelSheetFormValues(values$4);
            return dispatch({
              TAG: "LabelSheetEdited",
              _0: {
                priceId: init.priceId,
                productBarcodeDisplayed: init.productBarcodeDisplayed,
                missingProductBarcodeGenerated: init.missingProductBarcodeGenerated,
                priceDisplayed: init.priceDisplayed,
                producerDisplayed: init.producerDisplayed,
                alcoholVolumeDisplayed: init.alcoholVolumeDisplayed,
                designationDisplayed: init.designationDisplayed,
                productCode: init.productCode,
                labelFormat: "Grid21",
                printOffset: init.printOffset,
                borderEnabled: init.borderEnabled,
                sort: init.sort,
                productValues: init.productValues
              }
            });
          case "Grid64":
            let init$1 = toLabelSheetFormValues(values$4);
            return dispatch({
              TAG: "LabelSheetEdited",
              _0: {
                priceId: init$1.priceId,
                productBarcodeDisplayed: init$1.productBarcodeDisplayed,
                missingProductBarcodeGenerated: init$1.missingProductBarcodeGenerated,
                priceDisplayed: init$1.priceDisplayed,
                producerDisplayed: init$1.producerDisplayed,
                alcoholVolumeDisplayed: init$1.alcoholVolumeDisplayed,
                designationDisplayed: init$1.designationDisplayed,
                productCode: init$1.productCode,
                labelFormat: "Grid64",
                printOffset: init$1.printOffset,
                borderEnabled: init$1.borderEnabled,
                sort: init$1.sort,
                productValues: init$1.productValues
              }
            });
          case "Label31x22":
            return dispatch({
              TAG: "LabelPrintEdited",
              _0: {
                priceId: values$4.priceId,
                productBarcodeDisplayed: values$4.productBarcodeDisplayed,
                missingProductBarcodeGenerated: values$4.missingProductBarcodeGenerated,
                priceDisplayed: values$4.priceDisplayed,
                producerDisplayed: values$4.producerDisplayed,
                alcoholVolumeDisplayed: values$4.alcoholVolumeDisplayed,
                designationDisplayed: values$4.designationDisplayed,
                productCode: values$4.productCode,
                labelFormat: "Label31x22",
                productValues: values$4.productValues
              }
            });
          case "Label57x19":
            return dispatch({
              TAG: "LabelPrintEdited",
              _0: {
                priceId: values$4.priceId,
                productBarcodeDisplayed: values$4.productBarcodeDisplayed,
                missingProductBarcodeGenerated: values$4.missingProductBarcodeGenerated,
                priceDisplayed: values$4.priceDisplayed,
                producerDisplayed: values$4.producerDisplayed,
                alcoholVolumeDisplayed: values$4.alcoholVolumeDisplayed,
                designationDisplayed: values$4.designationDisplayed,
                productCode: values$4.productCode,
                labelFormat: "Label57x19",
                productValues: values$4.productValues
              }
            });
        }
      }
    });
  }
  let match$13 = state.form;
  let tmp$2;
  if (match$13.TAG === "LabelSheet") {
    let match$14 = match$13._0;
    let values$5 = match$14.values;
    tmp$2 = JsxRuntime.jsx(make$5, {
      shopId: shop.id,
      priceId: values$5.priceId,
      printMode: false,
      productsTotalCount: productsTotalCount,
      products: values$5.productValues,
      errorMessage: isErrored(state) ? match$14.errorMessages.productValues : undefined,
      onChange: updater => dispatch({
        TAG: "LabelSheetProductsUpdated",
        _0: updater
      })
    });
  } else {
    let match$15 = match$13._0;
    if (match$15.settingsOnly !== undefined) {
      tmp$2 = null;
    } else {
      let values$6 = match$15.values;
      tmp$2 = JsxRuntime.jsx(make$5, {
        shopId: shop.id,
        priceId: values$6.priceId,
        printMode: true,
        productsTotalCount: productsTotalCount,
        products: values$6.productValues,
        errorMessage: isErrored(state) ? match$15.errorMessages.productValues : undefined,
        onChange: updater => dispatch({
          TAG: "LabelPrintProductsUpdated",
          _0: updater
        })
      });
    }
  }
  return JsxRuntime.jsx(ResourceDetailsPage.make, {
    variation: isSettingsOnlyMode(state) ? "compact" : "standard",
    title: pageTitle,
    subtitle: pageSubtitle,
    actionsBar: actionsBar,
    notificationBanner: notificationBanner,
    statusBadge: persistedSettingsIconTooltip,
    children: JsxRuntime.jsxs(Stack.make, {
      children: [invalidBarcodesBanner, initialStateSettingsBanner, JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Group.make, {
          children: [tmp, tmp$1],
          grid: ["50%", "50%"],
          wrap: false,
          spaceX: "medium"
        }), tmp$2],
        space: "medium"
      })],
      space: "medium"
    })
  });
});
let CatalogLabelCreatePageLoaded = {
  make: make$7
};
let Raw = {};
let query = Client.gql(["query PricesQuery($filterBy: InputPricesQueryFilter)  {\nprices(first: 50, filterBy: $filterBy)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nenableByDefault  \n}\n\n}\n\n}\n\n}\n"]);
function parse(value) {
  let value$1 = value.prices;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    prices: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            enableByDefault: value$1.enableByDefault
          }
        };
      })
    }
  };
}
function serialize(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.enableByDefault;
    let value$3 = value$1.name;
    let value$4 = value$1.id;
    let value$5 = value$1.__typename;
    let node = {
      __typename: value$5,
      id: value$4,
      name: value$3,
      enableByDefault: value$2
    };
    let value$6 = value.__typename;
    return {
      __typename: value$6,
      node: node
    };
  });
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$3.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$3.__typename;
  let pageInfo = {
    __typename: value$6,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$7 = value$1.__typename;
  let prices = {
    __typename: value$7,
    pageInfo: pageInfo,
    edges: edges
  };
  return {
    prices: prices
  };
}
function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectInputPricesQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    archived: a$1 !== undefined ? a$1 === "ONLY" ? "ONLY" : a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED" : undefined
  };
}
function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputPricesQueryFilter(a) : undefined
  };
}
function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}
function makeInputObjectInputPricesQueryFilter(shopIds, archived, param) {
  return {
    shopIds: shopIds,
    archived: archived
  };
}
function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}
function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}
let PricesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputPricesQueryFilter: serializeInputObjectInputPricesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputPricesQueryFilter: makeInputObjectInputPricesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});
let use = include.use;
let PricesQuery_refetchQueryDescription = include.refetchQueryDescription;
let PricesQuery_useLazy = include.useLazy;
let PricesQuery_useLazyWithVariables = include.useLazyWithVariables;
let PricesQuery = {
  PricesQuery_inner: PricesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputPricesQueryFilter: serializeInputObjectInputPricesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputPricesQueryFilter: makeInputObjectInputPricesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: PricesQuery_refetchQueryDescription,
  use: use,
  useLazy: PricesQuery_useLazy,
  useLazyWithVariables: PricesQuery_useLazyWithVariables
};
let Raw$1 = {};
let query$1 = Client.gql(["query QueryVariantsTotalCount($filterBy: InputVariantsQueryFilter)  {\nvariants(filterBy: $filterBy)  {\n__typename  \ntotalCount  \n}\n\n}\n"]);
function parse$1(value) {
  let value$1 = value.variants;
  return {
    variants: {
      __typename: value$1.__typename,
      totalCount: value$1.totalCount
    }
  };
}
function serialize$1(value) {
  let value$1 = value.variants;
  let value$2 = value$1.totalCount;
  let value$3 = value$1.__typename;
  let variants = {
    __typename: value$3,
    totalCount: value$2
  };
  return {
    variants: variants
  };
}
function serializeInputObjectInFilter$1(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectNullableStringEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a !== undefined ? a : undefined
  };
}
function serializeInputObjectNumberRangeFilter(inp) {
  let a = inp._min;
  let a$1 = inp._max;
  let a$2 = inp._between;
  return {
    _min: a !== undefined ? a : undefined,
    _max: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectInputVariantsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.stockKeepingUnit;
  let a$2 = inp.ean13;
  let a$3 = inp.active;
  let a$4 = inp.archived;
  let a$5 = inp.createdAt;
  let a$6 = inp.updatedAt;
  let a$7 = inp.categoryId;
  let a$8 = inp.supplierId;
  let a$9 = inp.stock;
  let a$10 = inp.producer;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$1(a) : undefined,
    stockKeepingUnit: a$1 !== undefined ? {
      _equals: a$1._equals
    } : undefined,
    ean13: a$2 !== undefined ? {
      _equals: a$2._equals
    } : undefined,
    active: a$3 !== undefined ? {
      _equals: a$3._equals
    } : undefined,
    archived: a$4 !== undefined ? a$4 === "ONLY" ? "ONLY" : a$4 === "INCLUDED" ? "INCLUDED" : "EXCLUDED" : undefined,
    createdAt: a$5 !== undefined ? serializeInputObjectDateFilter(a$5) : undefined,
    updatedAt: a$6 !== undefined ? serializeInputObjectDateFilter(a$6) : undefined,
    categoryId: a$7 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$7) : undefined,
    supplierId: a$8 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$8) : undefined,
    stock: a$9 !== undefined ? serializeInputObjectNumberRangeFilter(a$9) : undefined,
    producer: a$10 !== undefined ? {
      _equals: a$10._equals
    } : undefined
  };
}
function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}
function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}
function serializeVariables$1(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputVariantsQueryFilter(a) : undefined
  };
}
function makeVariables$1(filterBy) {
  return {
    filterBy: filterBy
  };
}
function makeInputObjectInputVariantsQueryFilter(shopIds, stockKeepingUnit, ean13, active, archived, createdAt, updatedAt, categoryId, supplierId, stock, producer, param) {
  return {
    shopIds: shopIds,
    stockKeepingUnit: stockKeepingUnit,
    ean13: ean13,
    active: active,
    archived: archived,
    createdAt: createdAt,
    updatedAt: updatedAt,
    categoryId: categoryId,
    supplierId: supplierId,
    stock: stock,
    producer: producer
  };
}
function makeInputObjectInFilter$1(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}
function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}
function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}
function makeInputObjectNullableStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}
function makeInputObjectNumberRangeFilter(_min, _max, _between, param) {
  return {
    _min: _min,
    _max: _max,
    _between: _between
  };
}
function makeDefaultVariables$1() {
  return {
    filterBy: undefined
  };
}
let VariantsCountQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables$1
};
let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});
let use$1 = include$1.use;
let VariantsCountQuery_refetchQueryDescription = include$1.refetchQueryDescription;
let VariantsCountQuery_useLazy = include$1.useLazy;
let VariantsCountQuery_useLazyWithVariables = include$1.useLazyWithVariables;
let VariantsCountQuery = {
  VariantsCountQuery_inner: VariantsCountQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables$1,
  refetchQueryDescription: VariantsCountQuery_refetchQueryDescription,
  use: use$1,
  useLazy: VariantsCountQuery_useLazy,
  useLazyWithVariables: VariantsCountQuery_useLazyWithVariables
};
function CatalogLabelCreatePage(props) {
  let __settingsOnly = props.settingsOnly;
  let settingsOnly = __settingsOnly !== undefined ? Primitive_option.valFromOption(__settingsOnly) : undefined;
  let navigate = Navigation.useNavigate();
  let shop = Auth.useScope();
  let match;
  match = shop.TAG === "Organisation" ? [shop.activeShop, true] : [shop._0, false];
  let shop$1 = match[0];
  let match$1 = React.useState(() => {});
  let setPrinterStatusResult = match$1[1];
  let printerStatusResult = match$1[0];
  let priceListResult = AsyncResult.mapOk(ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Stdlib_Option.isNone(shop$1), undefined, {
    filterBy: {
      shopIds: {
        _in: [Stdlib_Option.mapOr(shop$1, "", shop => shop.id)]
      },
      archived: undefined
    }
  })), param => param.prices.edges.map(edge => ({
    id: Stdlib_Option.getExn(Uuid.fromString(edge.node.id), undefined),
    name: edge.node.name,
    default: edge.node.enableByDefault
  })));
  let productsTotalCountResult = AsyncResult.mapOk(ApolloHelpers.queryResultToAsyncResult(use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Stdlib_Option.isNone(shop$1), undefined, {
    filterBy: makeInputObjectInputVariantsQueryFilter({
      _in: [Stdlib_Option.mapOr(shop$1, "", shop => shop.id)]
    }, undefined, undefined, {
      _equals: true
    }, "EXCLUDED", undefined, undefined, undefined, undefined, undefined, undefined, undefined)
  })), param => param.variants.totalCount);
  React.useEffect(() => {
    if (shop$1 === undefined) {
      return;
    }
    let future = CatalogLabel.Print.DefaultPrinterRequest.make(shop$1.id);
    Future.map(future, undefined, result => setPrinterStatusResult(param => result));
    return () => Future.cancel(future);
  }, [shop$1]);
  let persistedStateSettings = CatalogLabel.StateSettingsUserPreferences.useRead();
  let firstPersistence = Stdlib_Option.isNone(persistedStateSettings);
  let initialState = priceList => {
    if (persistedStateSettings === undefined) {
      if (Stdlib_Option.isSome(settingsOnly)) {
        return initializeStateLabelPrint(Primitive_option.some(settingsOnly), priceList, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      } else {
        return initializeStateLabelSheet(priceList, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      }
    }
    let labelFormat = persistedStateSettings.labelFormat;
    if (labelFormat.TAG === "LabelSheet") {
      if (Stdlib_Option.isSome(settingsOnly)) {
        return initializeStateLabelPrint(Primitive_option.some(settingsOnly), priceList, Primitive_option.some(persistedStateSettings.priceId), persistedStateSettings.productBarcodeDisplayed, persistedStateSettings.missingProductBarcodeGenerated, persistedStateSettings.priceDisplayed, persistedStateSettings.producerDisplayed, persistedStateSettings.alcoholVolumeDisplayed, persistedStateSettings.designationDisplayed, persistedStateSettings.productCode, undefined, undefined);
      } else {
        return initializeStateLabelSheet(priceList, Primitive_option.some(persistedStateSettings.priceId), persistedStateSettings.productBarcodeDisplayed, persistedStateSettings.missingProductBarcodeGenerated, persistedStateSettings.priceDisplayed, persistedStateSettings.producerDisplayed, persistedStateSettings.alcoholVolumeDisplayed, persistedStateSettings.designationDisplayed, persistedStateSettings.productCode, labelFormat._0, persistedStateSettings.printOffset, persistedStateSettings.borderEnabled, persistedStateSettings.sort, undefined);
      }
    } else {
      return initializeStateLabelPrint(Primitive_option.some(settingsOnly), priceList, Primitive_option.some(persistedStateSettings.priceId), persistedStateSettings.productBarcodeDisplayed, persistedStateSettings.missingProductBarcodeGenerated, persistedStateSettings.priceDisplayed, persistedStateSettings.producerDisplayed, persistedStateSettings.alcoholVolumeDisplayed, persistedStateSettings.designationDisplayed, persistedStateSettings.productCode, labelFormat._0, undefined);
    }
  };
  let tmp;
  let exit = 0;
  let exit$1 = 0;
  let exit$2 = 0;
  if (printerStatusResult !== undefined && printerStatusResult.TAG !== "Ok" && printerStatusResult._0 !== "NoPrinterFound") {
    tmp = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.error,
      title: I18n.t("An unexpected error occured."),
      text: I18n.t("Wino could not connect to your printer via the StarPrinter Online service."),
      children: JsxRuntime.jsx(Inline.make, {
        children: JsxRuntime.jsx(Button.make, {
          label: I18n.t("Setup the printer"),
          onPress: () => navigate(undefined, SettingsRoutes.labelPrinterRoute)
        }),
        align: "center"
      })
    });
  } else {
    exit$2 = 3;
  }
  if (exit$2 === 3) {
    if (typeof priceListResult !== "object" || priceListResult.TAG !== "Done" || priceListResult._0.TAG === "Ok") {
      exit$1 = 2;
    } else {
      tmp = JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    }
  }
  if (exit$1 === 2) {
    if (typeof productsTotalCountResult !== "object" || productsTotalCountResult.TAG !== "Done") {
      exit = 1;
    } else if (productsTotalCountResult._0.TAG === "Ok") {
      if (shop$1 !== undefined && printerStatusResult !== undefined && typeof priceListResult === "object" && priceListResult.TAG === "Done") {
        let printerStatus;
        printerStatus = printerStatusResult.TAG === "Ok" ? {
          TAG: "Ok",
          _0: undefined
        } : {
          TAG: "Error",
          _0: undefined
        };
        tmp = JsxRuntime.jsx(make$7, {
          firstPersistence: firstPersistence,
          shop: shop$1,
          organisation: match[1],
          printerStatus: printerStatus,
          productsTotalCount: productsTotalCountResult._0._0,
          initialState: initialState(priceListResult._0._0)
        });
      } else {
        exit = 1;
      }
    } else {
      tmp = JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    }
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  return JsxRuntime.jsx(CatalogPlaceholderShopPicker.make, {
    children: tmp,
    message: I18n.t("Please select the shop with which you would like to generate labels.")
  });
}
let make$8 = CatalogLabelCreatePage;
export { CatalogLabelCreateProductsValue, CatalogLabelCreateLabelSheetForm, CatalogLabelCreateLabelPrintForm, CatalogLabelCreateReducer, CatalogLabelCreateInformationCard, CatalogLabelCreatePrintSettingsCard, CatalogLabelCreateProductsCard, CatalogLabelCreatePageInvalidBarcodesBanner, CatalogLabelCreatePageLoaded, PricesQuery, VariantsCountQuery, make$8 as make };
/* validationErrorText Not a pure module */